"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Spinner = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Spinner"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Callout = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/Callout"));
var _TooltipLabel = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/TooltipLabel"));
var _utils = require("../utils");
var _Autocomplete = _interopRequireDefault(require("./Autocomplete"));
var _IdentityRow = _interopRequireDefault(require("./IdentityRow"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TeamIcon = function TeamIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0zM8.583 6.03a2.302 2.302 0 1 0 .016 4.566 1 1 0 1 1 .264 1.983 4.302 4.302 0 1 1-.03-8.533 1 1 0 1 1-.25 1.984zm3.738 8.503A7.001 7.001 0 0 1 22 21a1 1 0 1 1-2 0 5 5 0 1 0-10 0 1 1 0 1 1-2 0 7 7 0 0 1 4.321-6.467zm-4.338.383a1 1 0 0 1-.88 1.107A3.5 3.5 0 0 0 4 19.5a1 1 0 1 1-2 0 5.5 5.5 0 0 1 4.876-5.464 1 1 0 0 1 1.107.88z"
  }));
};
TeamIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "body": "ShareWithIdentitiesPanel__body__2UW0Q",
  "spinner-container": "ShareWithIdentitiesPanel__spinner-container__2zlWH",
  "spinnerContainer": "ShareWithIdentitiesPanel__spinner-container__2zlWH",
  "user-list-description": "ShareWithIdentitiesPanel__user-list-description__2aE8k",
  "userListDescription": "ShareWithIdentitiesPanel__user-list-description__2aE8k",
  "user-list-empty": "ShareWithIdentitiesPanel__user-list-empty__3TuoL",
  "userListEmpty": "ShareWithIdentitiesPanel__user-list-empty__3TuoL",
  "alert-warning": "ShareWithIdentitiesPanel__alert-warning__1DLzn",
  "alertWarning": "ShareWithIdentitiesPanel__alert-warning__1DLzn",
  "user-list-section": "ShareWithIdentitiesPanel__user-list-section__36-DJ",
  "userListSection": "ShareWithIdentitiesPanel__user-list-section__36-DJ",
  "modal-user-list": "ShareWithIdentitiesPanel__modal-user-list__1obqA",
  "modalUserList": "ShareWithIdentitiesPanel__modal-user-list__1obqA",
  "footer": "ShareWithIdentitiesPanel__footer__1KKm_",
  "tooltip-container": "ShareWithIdentitiesPanel__tooltip-container__3m3TK",
  "tooltipContainer": "ShareWithIdentitiesPanel__tooltip-container__3m3TK",
  "sharing-tooltip-content": "ShareWithIdentitiesPanel__sharing-tooltip-content__SUFTJ",
  "sharingTooltipContent": "ShareWithIdentitiesPanel__sharing-tooltip-content__SUFTJ",
  "link-anchor": "ShareWithIdentitiesPanel__link-anchor__2-R7T",
  "linkAnchor": "ShareWithIdentitiesPanel__link-anchor__2-R7T",
  "callout": "ShareWithIdentitiesPanel__callout__2us2Q"
}; 
require('./ShareWithIdentitiesPanel.css');
var hasNewAddedExternalIdentity = function hasNewAddedExternalIdentity(_ref) {
  var identities = _ref.identities;
  return identities.some(function (identity) {
    return (identity.type === 'external' || identity.identityType === 'externalOrganization') && identity.isNewIdentity;
  });
};
var renderIdentityListEmpty = function renderIdentityListEmpty() {
  return /*#__PURE__*/_react.default.createElement("section", {
    className: styles.userListEmpty,
    "data-test-id": "identity-list-empty"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    role: "presentation",
    "data-test-id": "team-icon-sharing",
    size: 75
  }, /*#__PURE__*/_react.default.createElement(TeamIcon, null)), "Add users to provide direct access");
};
var ShareWithIdentitiesPanel = /*#__PURE__*/function (_React$Component) {
  function ShareWithIdentitiesPanel(props, defaultProps) {
    var _this;
    (0, _classCallCheck2.default)(this, ShareWithIdentitiesPanel);
    _this = _callSuper(this, ShareWithIdentitiesPanel, [props, defaultProps]);
    (0, _defineProperty2.default)(_this, "state", {
      identities: null,
      isDirty: false
    });
    (0, _defineProperty2.default)(_this, "getIdentityWithRole", function (identity) {
      return _objectSpread(_objectSpread({}, identity), {}, {
        role: _this.getRole(identity.role)
      });
    });
    (0, _defineProperty2.default)(_this, "getRole", function (roleId) {
      var config = _this.props.config;
      return config.roles.find(function (role) {
        return role.id === roleId;
      });
    });
    (0, _defineProperty2.default)(_this, "getIdentities", function () {
      var identities = _this.state.identities;
      var assetIdentities = _this.props.assetIdentities;
      return identities || assetIdentities.map(_this.getIdentityWithRole);
    });
    (0, _defineProperty2.default)(_this, "handleShare", function () {
      var _this$props = _this.props,
        asset = _this$props.asset,
        onShare = _this$props.onShare;
      var identities = _this.getIdentities().map(function (i) {
        var identity = _objectSpread({}, i);
        var updatedRoleId = identity.updatedRole && identity.updatedRole.id;
        var hasSameRole = updatedRoleId === identity.role.id;
        if (identity.isMarkedAsDeleted || hasSameRole) {
          delete identity.updatedRole;
        }
        if (identity.isNewIdentity && updatedRoleId) {
          identity.role = _this.getRole(updatedRoleId);
          delete identity.updatedRole;
        }
        return identity;
      });
      onShare({
        groupId: asset.groupId,
        assetId: asset.assetId,
        identities: identities
      });
    });
    (0, _defineProperty2.default)(_this, "handleRoleChange", function (identity, newRoleId) {
      var identities = (0, _toConsumableArray2.default)(_this.getIdentities());
      var wantedIdentity = identities.find(function (newIdentity) {
        return newIdentity.id === identity.id;
      });
      if (wantedIdentity.role.id !== newRoleId) {
        wantedIdentity.updatedRole = _this.getRole(newRoleId);
      } else {
        delete wantedIdentity.updatedRole;
      }
      _this.updateStateIdentities({
        identities: identities
      });
    });
    (0, _defineProperty2.default)(_this, "handleDismiss", function () {
      var onClose = _this.props.onClose;
      onClose();
    });
    (0, _defineProperty2.default)(_this, "handleAddIdentity", function (_ref2) {
      var identity = _ref2.identity,
        role = _ref2.role;
      var identities = _this.getIdentities();
      var isAlreadyAdded = identities.some(function ($identity) {
        return $identity.id === identity.id;
      });
      if (!isAlreadyAdded) {
        var newIdentity = _objectSpread(_objectSpread({}, identity), {}, {
          role: _this.getRole(role),
          isNewIdentity: true
        });
        _this.updateStateIdentities({
          identities: [newIdentity].concat((0, _toConsumableArray2.default)(identities))
        });
      }
    });
    (0, _defineProperty2.default)(_this, "handleSearch", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(query) {
        var _this$props2, onSearch, profile, identities, request, retrievedIdentities;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, onSearch = _this$props2.onSearch, profile = _this$props2.profile;
              identities = _this.getIdentities();
              request = {
                query: query,
                organizationId: (0, _utils.getActiveOrganizationId)(profile),
                userId: profile.id,
                currentUsers: identities
              };
              _context.next = 5;
              return onSearch(request);
            case 5:
              retrievedIdentities = _context.sent;
              return _context.abrupt("return", retrievedIdentities.map(function (identity) {
                return _objectSpread(_objectSpread({}, identity), {}, {
                  isDisabled: !_this.isValidIdentity(identity)
                });
              }));
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(_this, "isValidIdentity", function (user) {
      var identities = _this.getIdentities();
      var isAlreadyAdded = identities.find(function (newUser) {
        return newUser.id === user.id;
      });
      var profile = _this.props.profile;
      var isLoggedUser = user.id === profile.id;
      return !isAlreadyAdded && !isLoggedUser;
    });
    (0, _defineProperty2.default)(_this, "handleRemoveIdentity", function (identity) {
      var newIdentities = _this.getIdentities();
      if (identity.isNewIdentity) {
        newIdentities = newIdentities.filter(function (newIdentity) {
          return newIdentity.id !== identity.id;
        });
      }
      newIdentities = newIdentities.map(function (newIdentity) {
        if (newIdentity.id === identity.id) {
          return _objectSpread(_objectSpread({}, newIdentity), {}, {
            isMarkedAsDeleted: true
          });
        }
        return newIdentity;
      });
      _this.updateStateIdentities({
        identities: newIdentities
      });
    });
    (0, _defineProperty2.default)(_this, "handleUndoRemoveIdentity", function (identity) {
      var newIdentities = _this.getIdentities().map(function (newIdentity) {
        if (newIdentity.id === identity.id) {
          return _objectSpread(_objectSpread({}, newIdentity), {}, {
            isMarkedAsDeleted: false
          });
        }
        return newIdentity;
      });
      _this.updateStateIdentities({
        identities: newIdentities
      });
    });
    var _this$props3 = _this.props,
      onLoadModal = _this$props3.onLoadModal,
      _asset = _this$props3.asset;
    onLoadModal(_asset);
    return _this;
  }
  (0, _inherits2.default)(ShareWithIdentitiesPanel, _React$Component);
  return (0, _createClass2.default)(ShareWithIdentitiesPanel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
        reset = _this$props4.reset,
        assetIdentities = _this$props4.assetIdentities;
      if (prevProps.reset !== reset) {
        this.updateStateIdentities({
          identities: assetIdentities.map(this.getIdentityWithRole)
        });
      }
    }
  }, {
    key: "updateStateIdentities",
    value: function updateStateIdentities(_ref4) {
      var identities = _ref4.identities;
      var onUpdate = this.props.onUpdate;
      var hasNewIdentities = identities.some(function (identity) {
        return identity.isNewIdentity;
      });
      var hasIdentitiesMarkedAsDeleted = identities.some(function (identity) {
        return identity.isMarkedAsDeleted;
      });
      var hasIdentitiesWithDifferentRoles = identities.some(function (identity) {
        return identity.updatedRole;
      });
      var isDirty = hasNewIdentities || hasIdentitiesMarkedAsDeleted || hasIdentitiesWithDifferentRoles;
      this.setState({
        identities: identities,
        isDirty: isDirty
      }, function () {
        return onUpdate(isDirty);
      });
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var config = this.props.config;
      var label = 'What am I sharing?';
      var tooltipContent = /*#__PURE__*/_react.default.createElement("div", {
        className: styles.sharingTooltipContent
      }, "When you share an asset, you are sharing all its asset properties, including the name, description, icon, markdown pages, categories, tags, asset versions and files.", /*#__PURE__*/_react.default.createElement("a", {
        href: config.docsLinks.sharing,
        className: styles.linkAnchor,
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Learn more"));
      return /*#__PURE__*/_react.default.createElement(_TooltipLabel.default, {
        id: "snapshot",
        label: label,
        tooltipHeader: null,
        tooltipContent: tooltipContent
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props5 = this.props,
        isUserListLoading = _this$props5.isUserListLoading,
        isShareLoading = _this$props5.isShareLoading,
        profile = _this$props5.profile,
        CustomCallout = _this$props5.CustomCallout;
      var loggedUserId = profile.id;
      var isDirty = this.state.isDirty;
      var identities = this.getIdentities();
      var isIdentityListEmpty = identities.length === 0;
      var showExternalWarning = hasNewAddedExternalIdentity({
        identities: identities
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
        testId: "modal-body",
        className: styles.body
      }, isUserListLoading ? /*#__PURE__*/_react.default.createElement("div", {
        className: styles.spinnerContainer,
        "data-test-id": "internal-share-modal-spinner"
      }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        className: styles.spinner,
        center: true,
        size: "l"
      })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
        "aria-label": "Search users and teams"
      }, "Invite specific users and teams to have access", /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
        isUserListLoading: isUserListLoading,
        onAddIdentity: this.handleAddIdentity,
        onSearch: this.handleSearch,
        loggedUserId: loggedUserId
      })), isIdentityListEmpty ? renderIdentityListEmpty() : /*#__PURE__*/_react.default.createElement("section", {
        "aria-label": "List of users and teams with roles",
        className: styles.userListSection
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: styles.userListDescription
      }, "Who has access"), /*#__PURE__*/_react.default.createElement("ul", {
        "aria-live": "assertive",
        className: styles.modalUserList,
        "data-test-id": "modal-user-list"
      }, identities.map(function (identity) {
        return /*#__PURE__*/_react.default.createElement(_IdentityRow.default, {
          key: identity.id,
          identity: identity,
          onRoleChange: _this2.handleRoleChange,
          onRemoveIdentity: _this2.handleRemoveIdentity,
          onUndoRemoveIdentity: _this2.handleUndoRemoveIdentity,
          isCurrentUser: loggedUserId === identity.id
        });
      }))), showExternalWarning ? /*#__PURE__*/_react.default.createElement(_Callout.default, {
        className: styles.callout,
        testId: "external-identity-warning-share-message",
        type: "warning"
      }, "Some of the newly added users are outside of your organization.") : null, /*#__PURE__*/_react.default.createElement(CustomCallout, null))), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
        className: styles.footer,
        testId: "modal-footer"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: styles.tooltipContainer
      }, this.renderTooltip()), /*#__PURE__*/_react.default.createElement(_Button.default, {
        testId: "share-modal-cancel-button",
        kind: "tertiary",
        className: styles.modalButton,
        disabled: isShareLoading,
        onClick: this.handleDismiss,
        noFill: true
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_Button.default, {
        testId: "share-modal-share-button",
        kind: "primary",
        isLoading: isShareLoading,
        className: styles.modalButton,
        disabled: isShareLoading || !isDirty,
        onClick: this.handleShare
      }, "Save")));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(ShareWithIdentitiesPanel, "defaultProps", {
  assetIdentities: [],
  isUserListLoading: false,
  onClose: function onClose() {},
  onSearch: function onSearch() {},
  onUpdate: function onUpdate() {},
  onShare: function onShare() {},
  reset: false,
  CustomCallout: function CustomCallout() {
    return null;
  }
});
var _default = exports.default = ShareWithIdentitiesPanel;
//# sourceMappingURL=ShareWithIdentitiesPanel.js.map